import { createToastManager } from "@lib/components/Toast";

export const toastManager = createToastManager();
